import { Vector3, type Object3D } from 'three';
import type { Engine } from '../Engine';

type PrewarmOptions = {
  /** Move object offscreen during prewarm to avoid visible pop-in */
  hideOffscreen?: boolean;
  offscreenPosition?: { x: number; y: number; z: number };
};

export function prewarmObjectVisibility(
  engine: Engine,
  object: Object3D,
  frames = 1,
  options: PrewarmOptions = {}
): Promise<void> {
  const previousVisible = object.visible;
  const previousPosition: Vector3 | null = options.hideOffscreen ? object.position.clone() : null;

  if (options.hideOffscreen) {
    const target = options.offscreenPosition ?? { x: 0, y: -9999, z: 0 };
    object.position.set(target.x, target.y, target.z);
  }

  object.visible = true;

  return new Promise((resolve) => {
    let remaining = Math.max(1, frames);
    const unsubscribe = engine.onRender(() => {
      if (remaining <= 0) {
        if (previousPosition) {
          object.position.copy(previousPosition);
        }
        object.visible = previousVisible;
        unsubscribe();
        resolve();
        return;
      }
      remaining -= 1;
    });
  });
}
